module.exports = __webpack_public_path__ + "assets/img/6-6.3376312d.png";